import { CommonModule } from '@angular/common';
import { Component, input, OnInit, output } from '@angular/core';
import { EComponentSize, EIcon } from '../../types';
import { IconComponent } from '../icon/icon.component';
import { Types } from 'shared-lib';

@Component({
  selector: 'ui-photo',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './photo.component.html',
  styleUrl: './photo.component.scss'
})
export class PhotoComponent implements OnInit {
  imageUrl = input<string>('/images/user_image.png');
  size = input<EComponentSize>(EComponentSize.Large);
  id = input<number | string>(0);
  editable = input<boolean>(false);
  excludable = input<boolean>(false);
  isCircular = input<boolean>(false);

  valueChange = output<{ id: number | string; file: File }>();
  action = output<void>();
  valueDeleted = output<{ id: number | string; }>();

  isHovering: boolean = false;
  image: string = '';
  EIcon = EIcon;
  EAlert = Types.EAlert;
  excludableValue = this.excludable();

  ngOnInit(): void {
    this.image = this.imageUrl();
    this.excludableValue = this.excludable();
    if (!this.image) {
      this.excludableValue = false;
    }
  }
  getSizeClass(): string {
    const sizeMap = {
      [EComponentSize.Small]: 'w-32 h-32',
      [EComponentSize.Medium]: 'w-40 h-40',
      [EComponentSize.Large]: 'w-48 h-48',
      [EComponentSize.ExtraLarge]: 'w-56 h-56',
    };
    return sizeMap[this.size()] || 'w-40 h-40';
  }

  onFileChange(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const newUrl = reader.result as string;
        this.image = newUrl;
        const data = {
          id: this.id(),
          file: file
        }
        this.valueChange.emit(data);
      };
      reader.readAsDataURL(file);
    }
  }

  onTrashClick(event: Event) {
    event.stopPropagation();
    const data = {
      id: this.id(),
    }
    this.valueDeleted.emit(data);
  }
}

